import React, { Component } from 'react'

import DropMenu from '../DropMenu'

export default class SortMenu extends Component {
  render () {
    const { open, closeMenu, updateSortOrder, manualDisabled } = this.props

    return (
      <div>
        <DropMenu
          style={{ right: 'auto', marginTop: '10px', marginLeft: '10px' }}
          open={open}
          closeMenu={closeMenu}
          items={[
            {
              text: 'Relevance',
              onClick: () => updateSortOrder('relevance')
            },
            {
              text: 'Rating',
              onClick: () => updateSortOrder('rating', 'desc'),
              extra: [
                {
                  icon: 'chevron-down',
                  onClick: () => updateSortOrder('rating', 'desc')
                },
                {
                  icon: 'chevron-up',
                  onClick: () => updateSortOrder('rating', 'asc')
                }
              ]
            },
            {
              text: 'Date',
              onClick: () => updateSortOrder('date', 'desc'),
              extra: [
                {
                  icon: 'chevron-down',
                  onClick: () => updateSortOrder('date', 'desc')
                },
                {
                  icon: 'chevron-up',
                  onClick: () => updateSortOrder('date', 'asc')
                }
              ]
            },
            {
              text: 'Event',
              onClick: () => updateSortOrder('event', 'desc'),
              extra: [
                {
                  icon: 'chevron-down',
                  onClick: () => updateSortOrder('event', 'desc')
                },
                {
                  icon: 'chevron-up',
                  onClick: () => updateSortOrder('event', 'asc')
                }
              ]
            },
            {
              text: 'Filename',
              onClick: () => updateSortOrder('filename', 'desc'),
              extra: [
                {
                  icon: 'chevron-down',
                  onClick: () => updateSortOrder('filename', 'desc')
                },
                {
                  icon: 'chevron-up',
                  onClick: () => updateSortOrder('filename', 'asc')
                }
              ]
            },
            {
              text: 'Manual',
              onClick: () => updateSortOrder('manual'),
              disabled: manualDisabled
            }
          ]}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/album/SortMenu.js